import React from 'react'
import styles from './characteristicsTable.module.scss'
import { Specification } from '../especificaciones/Especificaciones'
import { t } from '../../../../common/i18n'
import SectionWithHeading from '../../../components/SectionWithHeading/SectionWithHeading'
import WhiteBoxContainer from '../../../components/WhiteBoxContainer'

interface Props {
  specifications: Array<Specification>
}

export const CharacteristicsTable: React.FC<Props> = ({ specifications }) => (
  <SectionWithHeading title={t('baterias.ficha.info.caracteristicas_tecnicas')}>
    <div className={styles.characteristics}>
      <WhiteBoxContainer className="fullWidthContent">
        <dl className={styles.characteristics__table}>
          {specifications.map((spec, index) => (
            <div key={index}>
              <dt>{spec.label}</dt>
              <dd>{spec.value || '-'}</dd>
            </div>
          ))}
        </dl>
      </WhiteBoxContainer>
    </div>
  </SectionWithHeading>
)
